import { inject, Injectable } from '@angular/core';
import { ModalServiceModel } from '@app/core/services/modal-manager/modal-service.model';
import { OrderSummaryComponent } from './order-summary.component';
import { ModalManagerInterface } from '@app/core/services/modal-manager';
import { Observable } from 'rxjs';
import { ViewOptions, ViewService } from '@makiwin/ngx-drupal8-rest';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root',
})
export class OrderSummaryService extends ModalServiceModel {
  private viewService = inject(ViewService);
  protected component = OrderSummaryComponent;
  protected options: NgbModalOptions = {
    size: 'lg',
    fullscreen: false,
    windowClass: 'd-flex modal-dialog-centered modal-dialog-full-width',
    backdrop: 'static',
  };
  isLoading = false;
  order?: any;

  open(modalManager: ModalManagerInterface, extraData: { orderId: number }): Observable<any> {
    this.isLoading = true;
    const viewOptions: ViewOptions = {
      args: [extraData.orderId],
    };
    this.viewService.get('/api/v1/user_orders.json', viewOptions).subscribe((data) => {
      this.order = data[0];
      this.isLoading = false;
      if (!this.order) {
        this.modalService.dismissAll();
        return;
      }
    });
    return super.open(modalManager, extraData);
  }
}
